// <tw-arcs> — TripWorks brand field: blue gradient + large slow-drifting arcs. Attr: calm (no motion).
(function () {
  if (customElements.get('tw-arcs')) return;
  const SHAPES = [
    { s: 1.5, x: -0.62, y: 0.42, bg: 'rgba(255,255,255,.055)', dx: 0.04, dy: -0.03, d: 38000 },
    { s: 1.25, x: 0.52, y: -0.55, bg: 'rgba(8,16,70,.24)', dx: -0.05, dy: 0.04, d: 46000 },
    { s: 0.95, x: 0.28, y: 0.18, ring: 'rgba(252,228,196,.16)', dx: 0.03, dy: 0.03, d: 52000 },
  ];
  class TwArcs extends HTMLElement {
    connectedCallback() {
      this.style.cssText +=
        ';display:block;position:relative;width:100%;height:100%;overflow:hidden;background:linear-gradient(135deg,#1F3BCB 0%,#1C3096 55%,#182569 100%)';
      this.els = SHAPES.map((sh) => {
        const e = document.createElement('div');
        e.setAttribute('aria-hidden', 'true');
        e.style.cssText =
          'position:absolute;border-radius:50%;will-change:transform;' +
          (sh.ring ? 'border:1.5px solid ' + sh.ring : 'background:' + sh.bg);
        this.appendChild(e);
        return e;
      });
      this.ro = new ResizeObserver(() => this.layout());
      this.ro.observe(this);
    }
    disconnectedCallback() {
      this.ro && this.ro.disconnect();
      (this.anims || []).forEach((a) => a.cancel());
    }
    layout() {
      const w = this.clientWidth,
        h = this.clientHeight;
      if (!w) return;
      const base = Math.max(w, h * 1.2),
        still = this.hasAttribute('calm') || matchMedia('(prefers-reduced-motion: reduce)').matches;
      (this.anims || []).forEach((a) => a.cancel());
      this.anims = SHAPES.map((sh, i) => {
        const e = this.els[i],
          size = base * sh.s;
        Object.assign(e.style, {
          width: size + 'px',
          height: size + 'px',
          left: w * sh.x + 'px',
          top: h * sh.y + 'px',
        });
        if (still) return { cancel() {} };
        return e.animate(
          [{ transform: 'translate(0,0)' }, { transform: `translate(${base * sh.dx}px,${base * sh.dy}px)` }],
          { duration: sh.d, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' },
        );
      });
    }
  }
  customElements.define('tw-arcs', TwArcs);
})();
